<template>
  <div class="d-flex justify-center align-center flex-column">
    <div v-if="!isActivePlan">
      <span>O Zaper Bot no Telegram é exclusivo para os clientes pro.</span>
    </div>
    <div v-else-if="loading" class="d-flex justify-center align-center flex-column">
      <v-progress-circular
        :width="3"
        :size="60"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <small class="mt-6">Por favor, aguarde enquanto estamos gerando seu código...</small>
    </div>
    <div v-else-if="!user.telegram" class="d-flex flex-column align-center">
      <strong style="font-size: 2em;">{{user.telegram_code}}</strong>
      <span class="mt-3">
        Acesse <a href="https://t.me/ZprsBot" target="_blank">@ZprsBot</a> no Telegram e envie o código acima.
      </span>
    </div>
    <div v-else class="d-flex flex-column align-center">
      <span>Você possui um telegram vinculado à esta conta</span>
      <v-btn color="red" class="mt-5" depressed dark @click="revoke()">Revogar acesso</v-btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    }
  },
  created () {
    this.interval = setInterval(() => this.$store.dispatch('auth/fetchUser'), 5000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  async mounted () {
    this.loading = true
    await this.$store.dispatch('auth/fetchUser')
    if (!this.user.telegram && this.isActivePlan) {
      await this.$store.dispatch('auth/getTelegramCode')
    }
    this.loading = false
  },
  methods: {
    async revoke () {
      this.loading = true
      await this.$store.dispatch('auth/revokeTelegram')
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>